import { styled } from '@mode/components'

export const Grid = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
})

export const GridTwo = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column',
  height: '100%',
  flexWrap: 'wrap',
})

export const GridItem = styled('div', {
  width: '100%',
  background: '$g1',
  borderRadius: '$16',
  padding: '$xxxs',
  py: '$sm',
  position: 'relative',
  zIndex: '3',
  fontFamily: '$serif',
  height: 'auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  '@md': {
    width: 'calc(42% - 10px)',
    padding: '$sm',
    height: 'auto',
  },

  '&:first-of-type': {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    '@md': {
      borderRadius: '$16',
    }
  },

  '&:last-of-type': {
    background: '#C8F169',
    mt: '$sm',
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    '@md': {
      mt: 0,
      borderRadius: '$16'
    }
  },
})

export const GridItemTwo = styled('div', {
  width: '100%',
  height: '0',
  borderRadius: '$16',
  position: 'relative',
  zIndex: 0,
  '@md': {
    height: 'auto',
    width: 'calc(16% - 20px)',
  }
})

export const GridItemThree = styled('div', {
  width: 'calc(50% - 9px)',
  height: '56px',
  background: '$g2',
  borderRadius: '$16',
  position: 'absolute',

  '@md': {
    width: 'calc(100% + 40px)',
    height: 'calc(55% - 10px)',
    position: 'relative',
  },

  '&:first-of-type': {
    borderTopRightRadius: '0',
    borderTopLeftRadius: '$16',
    borderBottomRightRadius: 0,
    zIndex: '100',
    top: '18px',
    right: 0,
    '@md': {
      left: 0,
      top: 0,
      borderBottomLeftRadius: '$16',
      borderTopLeftRadius: '$16',
      borderTopRightRadius: 0,
    },
    '&:after': {
      content: '',
      position: 'absolute',
      background: '$g2',
      width: '24px',
      height: '24px',
      bottom: '18px',
      left: '-24px',
      borderTopLeftRadius: '$6',
      '@md': {
        right: '20px',
        bottom: '-24px',
        left: 'unset',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderTopLeftRadius: 0,
      }
    },
    '&:before': {
      content: '',
      position: 'absolute',
      background: '$g5',
      width: '24px',
      height: '24px',
      bottom: '18px',
      left: '-24px',
      zIndex: '1',
      borderBottomRightRadius: '$16',
      borderTopLeftRadius: '$6',
      '@md': {
        right: '20px',
        left: 'unset',
        borderTopRightRadius: '$16',
        borderTopLeftRadius: 0,
        bottom: '-24px',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      }
    },
  },

  '&:last-of-type': {
    height: '56px',
    left: 0,
    top: '-18px',
    borderTopRightRadius: '$16',
    borderBottomLeftRadius: '0',
    borderTopLeftRadius: 0,
    background: '$g1',
    '@md': {
      height: 'calc(45% - 10px)',
      top: 0,
      left: '-40px',
      borderTopRightRadius: '$16',
      borderTopLeftRadius: '0',
      borderBottomRightRadius: '$16',
    },
    '&:after': {
      content: '',
      position: 'absolute',
      background: '$g1',
      width: '24px',
      height: '24px',
      top: '18px',
      right: '-23px',
      '@md': {
        top: '-24px',
        left: '20px',
        right: 'unset',
      }
    },
    '&:before': {
      content: '',
      position: 'absolute',
      background: '#043F2E',
      width: '24px',
      height: '24px',
      top: '18px',
      right: '-24px',
      zIndex: '1',
      borderTopLeftRadius: '$16',
      '@md': {
        borderBottomLeftRadius: '$16',
        borderBottomRightRadius: 0,
        borderTopLeftRadius: 0,
        left: '20px',
        top: '-24px',
        right: 'unset',
      }
    }
  }
})